<script>
  import { xyzSource } from '../../mixin'

  export default {
    name: 'vl-source-xyz',
    mixins: [xyzSource],
  }
</script>
